import React from 'react'
import { Helmet } from 'react-helmet'
import FooterSection from '../Footer'
import Header from '../Header'
import phone from '../../assets/img/phone.png'
import address from '../../assets/img/address.png'
import chat from '../../assets/img/chat.png'
import map from '../../assets/img/map.png'
import contact from '../../assets/video/gandirs3.mp4'
import contactMobile from '../../assets/video/contact.mp4'

const tempData = [
  {
    name: 'Цахим шуудан',
    desc: 'contact@cellclinic.mn',
    buttonText: 'Шуудан илгээх',
    img: chat
  },
  {
    name: 'Утас',
    desc: 'Да-Ба / 08:00 - 17:00',
    buttonText: '7776-0000',
    img: phone
  },
  {
    name: 'Хаяг',
    desc: 'Монгол улс, Улаанбаатар хот, Чингэлтэй дүүрэг, 1-р хороо, Баруун сэлбийн гудамж, 5/26-р байр, Гандирс цогцолбор, 3-р давхар',
    buttonText: '',
    img: address
  }
]

export default function ContactUs () {
  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>
      <Header color='blue' gradientColor='white' />
      <div className='h-[92vh] flex flex-col justify-between mobile:flex-col mobile:h-[100vh] mobile:w-full mobile:p-5 tablet:w-full '>
        <div className='flex-1 flex flex-col items-center justify-center text-white mobile:flex-row tablet:flex-row tablet:h-full'>
          <div className='flex flex-row items-center justify-center mobile:flex-col tablet:h-[100vh] tablet:flex-col mobile:h-[140vh] px-20 py-10 mobile:px-5 mobile:py-0 '>
            {/* Contact Info Section */}
            <div
              className='w-[360px] h-full flex flex-col justify-start items-start p-10 bg-[#3784C7] rounded-lg shadow-lg rounded-r-none
            mobile:w-full mobile:h-[80vh] mobile:rounded-r-lg 
            tablet:h-full tablet:w-full 
            extraScreen:w-[400px] maxScreen:w-[400px]'
            >
              <h2 className='text-[22px] font-bold'>Холбоо барих</h2>
              {tempData.map((item, index) => (
                <div key={index} className='flex items-start gap-2 mt-4'>
                  <img src={item.img} className='h-6 w-6' alt={item.name} />
                  <div>
                    <span className='font-semibold text-[12px] '>
                      {item.name}
                    </span>
                    <p className='mt-1 text-[14px] mobile:text-[12px] w-full text-white/55'>
                      {item.desc}
                    </p>
                    {item.buttonText && (
                      <button className='mt-1 px-4 py-1 rounded-lg border border-white/20 bg-white/20 text-white hover:bg-white/30 tablet:text-[12px]'>
                        {item.buttonText}
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <div
                className='mt-5 mobile:h-[3vh] mobile:w-full cursor-pointer tablet:hidden'
                onClick={() =>
                  window.open('https://maps.app.goo.gl/YcxiWP69pJURAXEm9')
                }
              >
                <img
                  src={map}
                  className='h-[200px] w-full rounded-lg  mobile:w-full mobile:h-[24vh] tablet:h-[16vh] tablet:w-full'
                  alt='ss'
                ></img>
              </div>
            </div>
            {/* Video Section */}
            <div
              className='w-full h-full rounded-lg rounded-l-none overflow-hidden shadow-lg 
            mobile:w-full  mobile:mt-2 mobile:rounded-l-lg tablet:rounded-none mobile:hidden
            '
            >
              <video
                className='h-full w-full object-cover '
                autoPlay
                muted
                loop
              >
                <source src={contact} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div>
            <div
              className='h-[70vh] rounded-lg rounded-l-none overflow-hidden shadow-lg 
            mobile:w-full  mobile:mt-2 mobile:rounded-l-lg 
            tablet:w-full tablet:h-full
            hidden mobile:flex
            '
            >
              <video
                className='h-[70vh] w-full object-cover tablet:h-full'
                autoPlay
                muted
                loop
              >
                <source src={contactMobile} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className='w-full mobile:px-5 tablet:p-5 maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto px-14'>
          <FooterSection />
        </div>
      </div>
    </>
  )
}
